import { svgImage } from '@/assets/svg/svg-icon';
import { useState } from 'react';
import { ModalConfirm } from '@/components'
import { createAsset } from '@/utils/apiEndpoints'
import { s3Upload } from '@/utils/aws'
import { Button, Form, Upload, message } from 'antd'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

// Import the Dragger component
const { Dragger } = Upload;
const FORBIDDEN_EXTENSIONS = ['.exe', '.js', '.sh', '.dmg', '.app', '.bat', '.cmd', '.php', '.py'];
const MAX_FILE_SIZE_MB = 5;

// const imageFormats = [
//   'image/png',
//   'image/jpeg',
//   'image/bmp',
//   'image/jpg',
//   'image/svg',
// ];

const AssetInput = ({
  onChange = () => {},
  type = '',
  value = [],
  maxCount = 10,
}) => {
  // const accept = type === 'image' ? imageFormats.join(',') : '';

  // Consolidate all the props for the Dragger component into one object
  const draggerProps = {
    multiple: maxCount > 1,
    maxCount: maxCount,
    fileList: value, // Show the list of selected files
    listType: "picture", // Use antd's built-in picture list style
    // accept: accept,
    onRemove: (file) => {
        // This logic is good, but let's make it safer
        const newFileList = value.filter(item => item.uid !== file.uid);
        onChange(newFileList);
    },
    beforeUpload: (file, fileList) => {
        const filesToAdd = [];
        let validationFailed = false;

        // Iterate over all selected files
        for (const f of fileList) {
          const isTooLarge = file.size / 1024 / 1024 > MAX_FILE_SIZE_MB;
          const hasForbiddenExtension = FORBIDDEN_EXTENSIONS.some(ext =>
              file.name.toLowerCase().endsWith(ext)
          );
          if (isTooLarge) {
              message.error(`'${file.name}' is too large (Max: ${MAX_FILE_SIZE_MB}MB).`);
              validationFailed = true;
          }
          else if (hasForbiddenExtension) {
              message.error(`'${file.name}' is a forbidden file type.`);
              validationFailed = true;
          }
          else {
            filesToAdd.push(f);
          }
        }

        // Only call onChange if there are valid files to add.
        if (filesToAdd.length > 0) {
            onChange([...value, ...filesToAdd]);
        }
        
        // Always return false to prevent automatic upload.
        return false;
    },
  };

  return (
    // Use the Dragger component for a built-in, reliable drop zone
    <Dragger {...draggerProps}>
        <p className="ant-upload-drag-icon">
            {svgImage.dropImage}
        </p>
        <p className="ant-upload-text">
            Drop your file, or <span className="browse">browse</span>
        </p>
        <p className="ant-upload-hint">
            Max file size is {MAX_FILE_SIZE_MB}MB
        </p>
    </Dragger>
  );
};
export const AddAsset = ({
  onUpload = () => { },
  type = '',
  maxCount = 1,
  organizationId,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const { currentUser } = useSelector((state) => state.auth)
  const [loading, setLoading] = useState(false)
  const params = useParams()
  const onAdd = () => {
    setIsOpen(true)
  }

  const assetFormItems = () => {
    return (
      <>
        <Form.Item
          name="asset"
          rules={[
            {
              required: true,
              message: 'Please select file to add as asset.',
            },
          ]}
        >
          <AssetInput maxCount={maxCount} type={type} />
        </Form.Item>
        {/* <Form.Item label="Rename asset" name="caption">
          <Input />
        </Form.Item> */}
      </>
    )
  }
  const onSubmit = async (values) => {
    console.log('onSubmit values:', values);
    setLoading(true)
    const { asset, caption } = values || {}
    const promises = []

    asset &&
      asset.map(async (file) => {
        promises.push(
          new Promise(async (resolve) => {
            if (typeof file === 'object') {
              try {
                const url = await s3Upload(file, currentUser.id)
                const asset = await createAsset({
                  url: url,
                  caption: caption || file.name,
                  type: file.type,
                  organizationId: organizationId || params.organization_id,
                })
                return resolve(asset.result)
              } catch (err) {
                return resolve(err)
              }
            } else return resolve('Not a object')
          }),
        )
        return file
      })
    const assetList = await Promise.all(promises)
    setIsOpen(false)
    setLoading(false)
    onUpload(assetList)
  }
  return (
    <>
      <Button
        type="primary"
        className="icon-holder add-assets-button"
        onClick={onAdd}
      >
        Add assets
      </Button>
      <ModalConfirm
        visible={isOpen}
        loading={loading}
        className='add-asset-modal'
        okButtonProps={{ size: 'large' }}
        cancelButtonProps={{ size: 'large' }}
        formItems={assetFormItems}
        title={'Add asset'}
        initialValues={{}}
        okText="Upload"
        onSubmit={(values) => onSubmit(values)}
        onCancel={() => {
          setIsOpen(false)
        }}
      />
    </>
  )
}
